interface ErrorDisplayProps {
  error: string;
}

function ErrorDisplay({ error }: ErrorDisplayProps): JSX.Element {
  return (
    <div className="App-error-section">
      <div className="App-error-card">
        <div className="App-error-icon">❌</div>
        <div className="App-error-content">
          <h3 className="App-error-title">Validation Error</h3>
          <p className="App-error-message">{error}</p>
        </div>
      </div>
    </div>
  );
}

export default ErrorDisplay;

